import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  adminAccessMap,
  menuItems,
} from '../../../utils/adminAccessAndNavBarData';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';

const MainNav = ({ isOpen, toggleSidebar }) => {
  const { profile, profileLoader } = useSelector((state) => state.profile);

  const currentAdminRole = profile?.adminType;

  const allowedRoutes = adminAccessMap[currentAdminRole];

  const filteredMenuItems =
    allowedRoutes === 'all'
      ? menuItems
      : menuItems?.filter((item) => allowedRoutes?.includes(item?.path));

  return (
    <div className={`main-nav lg:block ${isOpen ? 'block' : 'hidden'}`}>
      {/* Logo and Toggle Button */}
      <div className="flex justify-between items-center p-4">
        <NavLink to="/">
          <img
            src="/assets/img/logo/glorious_1.webp"
            alt="Logo"
            className="w-[16rem]"
          />
        </NavLink>

        <button
          onClick={() => toggleSidebar(!isOpen)}
          className="lg:hidden p-2"
          aria-label="Toggle Menu"
        >
          <iconify-icon icon="solar:backspace-bold"></iconify-icon>
        </button>
      </div>

      {/* Sidebar Navigation */}

      <div className="scrollbar p-4" data-simplebar>
        <ul className="navbar-nav space-y-2 h-[82%] pb-8 overflow-y-scroll">
          <li className="menu-title">General</li>

          {profileLoader ? (
            <div className="flex flex-col gap-4">
              <Skeleton height={60} width={'100%'} style={{ margin: 0 }} />
              <Skeleton height={60} width={'100%'} style={{ margin: 0 }} />
              <Skeleton height={60} width={'100%'} style={{ margin: 0 }} />
              <Skeleton height={60} width={'100%'} style={{ margin: 0 }} />
            </div>
          ) : (
            filteredMenuItems.map(({ path, icon, text }) => (
              <li key={path} className="nav-item">
                <NavLink to={path} className="nav-link flex items-center gap-2">
                  <span className="nav-icon">
                    <iconify-icon icon={icon}></iconify-icon>
                  </span>
                  <span className="nav-text">{text}</span>
                </NavLink>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default MainNav;
